import React, { useState } from "react";
import {
  Card,
  Button,
  Typography,
  Space,
  message,
} from "antd";
import {
  MailOutlined,
  LogoutOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useAuth0 } from "@auth0/auth0-react";
import apiClient from "../utils/axios";

const { Title, Text } = Typography;

export const EmailVerification: React.FC = () => {
  const { logout, user, getAccessTokenSilently } = useAuth0();
  const [resending, setResending] = useState(false);

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  };

  const handleResendEmail = async () => {
    setResending(true);
    try {
      const token = await getAccessTokenSilently();
      
      const response = await apiClient.post("/api/access/resend-verification", {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      if (response.data.success) {
        message.success("Verification email sent!");
      } else {
        message.warning(response.data.message);
      }
    } catch (error) {
      console.error("Error resending verification email:", error);
      message.error("Failed to resend verification email. Please try again.");
    } finally {
      setResending(false);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "24px",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Card
        style={{ maxWidth: 480, width: "100%" }}
        title={
          <Space>
            <MailOutlined style={{ color: "#1890ff" }} />
            Email Verification
          </Space>
        }
        extra={
          <Button 
            type="text" 
            icon={<LogoutOutlined />} 
            onClick={handleLogout}
            title="Logout"
          >
            Logout
          </Button>
        }
      >
        <Space direction="vertical" size="large" style={{ width: "100%", textAlign: "center" }}>
          <div>
            <CheckCircleOutlined 
              style={{ 
                fontSize: "48px", 
                color: "#52c41a", 
                marginBottom: "16px" 
              }} 
            />
            <Title level={3} style={{ marginBottom: "8px" }}>Check Your Email</Title>
            <Text style={{ fontSize: "16px", color: "#666" }}>
              We sent a verification link to:
            </Text>
            <div style={{ marginTop: "8px" }}>
              <Text strong style={{ fontSize: "16px", color: "#1890ff" }}>
                {user?.email}
              </Text>
            </div>
          </div>

          <div style={{ 
            backgroundColor: "#f9f9f9", 
            padding: "16px", 
            borderRadius: "8px",
            textAlign: "left"
          }}>
            <Text style={{ fontSize: "14px", color: "#666" }}>
              1. Click the verification link in your email<br/>
              2. Return here and click Continue<br/>
              3. Check spam folder if needed
            </Text>
          </div>

          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Button
              type="primary"
              size="large"
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              style={{ width: "100%" }}
            >
              Continue
            </Button>
            
            <Button
              type="default"
              size="large"
              loading={resending}
              onClick={handleResendEmail}
              style={{ width: "100%" }}
            >
              Resend Email
            </Button>

            <Button
              type="text"
              onClick={handleLogout}
              style={{ width: "100%", marginTop: "8px" }}
            >
              Switch Account
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
}; 